var _rect, _path, _g, _path2, _path3, _circle, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 205,
    viewBox: "0 0 236 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 94.0178,
    width: 192,
    height: 110,
    fill: "url(#paint0_linear_5497_7821)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.166 63.3227C105.039 61.8193 110.247 61.7821 115.14 63.2157L201.676 88.5645C207.399 90.241 207.437 98.3351 201.729 100.065L115.378 126.232C110.337 127.759 104.95 127.72 99.9323 126.118L18.214 100.038C12.618 98.2521 12.6564 90.3204 18.2695 88.5888L100.166 63.3227Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5497_7821)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.5,
    cy: 92.0178,
    rx: 26.5,
    ry: 2,
    fill: "#7294FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7679 108.64L92.7837 114.274L142 21.9688L128.452 17.0423C126.53 16.3435 124.44 16.2506 122.464 16.7762L82.9578 27.2832C80.3294 27.9822 78.4999 30.3618 78.4999 33.0816L78.4999 103.298C78.4999 105.551 79.762 107.614 81.7679 108.64Z",
    fill: "url(#paint1_linear_5497_7821)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4571 38.656C90.4571 35.9015 92.3325 33.5009 95.005 32.8343L139.133 21.8275C142.919 20.8832 146.585 23.7471 146.585 27.6492L146.585 96.0242C146.585 98.6645 144.859 100.994 142.333 101.764L98.2054 115.205C94.3505 116.379 90.4571 113.495 90.4571 109.466L90.4571 38.656Z",
    fill: "#4671F6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 60.4681,
    r: 4,
    fill: "#4671F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.583 100.167C122.771 100.167 126.167 96.7715 126.167 92.5833C126.167 88.3952 122.771 85 118.583 85C114.395 85 111 88.3952 111 92.5833C111 96.7715 114.395 100.167 118.583 100.167Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99 65.5032C99 64.6128 99.5886 63.8296 100.444 63.582L134.444 53.7399C135.723 53.3697 137 54.3294 137 55.6611L137 63.4968C137 64.3872 136.411 65.1704 135.556 65.418L101.556 75.2601C100.277 75.6303 99 74.6706 99 73.3389L99 65.5032Z",
    fill: "url(#paint2_linear_5497_7821)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47.5032C99 46.6128 99.5886 45.8296 100.444 45.582L134.444 35.7399C135.723 35.3697 137 36.3294 137 37.6611L137 45.4968C137 46.3872 136.411 47.1704 135.556 47.418L101.556 57.2601C100.277 57.6303 99 56.6706 99 55.3389L99 47.5032Z",
    fill: "url(#paint3_linear_5497_7821)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5497_7821",
    x: 69,
    y: 76.0178,
    width: 81,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_5497_7821"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5497_7821",
    x1: 206,
    y1: 149.018,
    x2: 14,
    y2: 149.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5497_7821",
    x1: 117,
    y1: 2.46875,
    x2: 70,
    y2: 61.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5497_7821",
    x1: 103.5,
    y1: 76,
    x2: 99,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5497_7821",
    x1: 103.5,
    y1: 58,
    x2: 99,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.08887b3c0a684f2e165b1e48f38a169b.svg";
export { ForwardRef as ReactComponent };